import { useState, useEffect } from "react";
import Scale from "../../Inputs/Scale";
import { TextField, Alert } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Loader from "../../Tools/Loader";
import Error from "./Error";
import API from "../../../services/API/Study";
import Toast from "../../Tools/Toast";
import { txt } from "../../../services/translation";

export default function Assessment({enrollment, section}){

    const position = section.type.id.split('_').pop();

    const [data, setData] = useState(null)
    const [error, setError] = useState(false)
    const [toast, setToast] = useState(false)
    const [missing, setMissing] = useState(false)
    const [saving, setSaving] = useState(false)

    useEffect(() => {

        API.getAssessment(enrollment?.id, position)
            .then(r => setData(r.data))
            .catch(e => setError(true))

    }, [enrollment, position])


    const handleSubmit = e => {
        e.preventDefault();

        setMissing(false);

        if(!data.q1 || !data.q2 || !data.q3 || !data.q4){
            setMissing(true);
            return false;
        }

        if(!enrollment) return handleSuccess();

        data.enrollment = enrollment;
        data.position = position;

        setSaving(true);

        return API.postAssessment(data)
            .then(r => handleSuccess())
            .catch(e => handleError())
    }

    const handleSuccess = () => {
        setSaving(false)
        return setToast(['success', txt('changesSavedSuccess')])
    }

    const handleError = () => {
        setSaving(false)
        return setToast(['error', txt('errorOccurred')])
    }

    if(error) return <Error />

    if(!data) return <Loader />

    return <form onSubmit={handleSubmit} style={{padding: '0px 10px'}}>

        <h3>{txt('evaluationTitle', { position: txt(position + 'Evaluation') })}</h3>

        {missing && <Alert severity='error'>{txt('evaluationMissing')}</Alert>}


        {data && <>

            <p>{txt('expertiseQuestion1')}</p>

            <Scale 
                value={data.q1}
                onChange={val => setData({...data, q1: val})}
            />

            <p className="mrg-t10">{txt('expertiseQuestion2')}</p>

            <Scale 
                value={data.q2}
                onChange={val => setData({...data, q2: val})}
            />

            <p className="mrg-t10">{txt('expertiseQuestion3')}</p>

            <Scale 
                value={data.q3}
                onChange={val => setData({...data, q3: val})}
            />

            <p className="mrg-t10">{txt('expertiseQuestion4')}</p>


            <TextField
                value={data.q4 || ''}
                onChange={e => setData({...data, q4: e.target.value})}
                inputProps={{
                    minLength: 3,
                    maxLength: 1000
                }}
                required
                multiline
                minRows={3}
                sx={{width: 300, mb: 2}}
            />

            <br/>

            <LoadingButton 
                type='submit' 
                variant='outlined'
                loading={saving}
            >
                {txt('save')}
            </LoadingButton>

            <Toast 
                open={toast} 
                severity={toast[0]} 
                message={toast[1]} 
                onClose={() => setToast(false)}
            />

        </>}

    </form>
}


